import { useRef } from "react";
import Input from "@weave-design/input";
import { noop } from "../../shared";
import { UserUniqueIdObjectPrefix } from "../ids/userObjectIds";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";

type Props = {
    prefix: UserUniqueIdObjectPrefix;
    idValue: number;
};

export const ObjectUserUniqueId = ({ prefix, idValue }: Props) => {
    const idInputRef = useRef<HTMLInputElement>();

    return (
        <PropertyEditor title="Id:">
            <Input
                inputRef={(x: HTMLInputElement) => (idInputRef.current = x)}
                onFocus={() => idInputRef.current?.select()}
                value={prefix + idValue}
                onChange={noop}
            />
        </PropertyEditor>
    );
};
